import React, { Component, useState } from "react";
import { DocumentInputRow } from "./DocumentInputRow";

export const DocumentUploadModal = (props) => {

    var id = props.id;
    var inputFor = props.inputFor;

    const atLeastOnefileAdded = () => {
        updateIfOneFileUploaded("File(s) attatched");
    }

    const [documentInputList, updateDocumentList] = useState([<DocumentInputRow key={0} inputFor={inputFor} id={id} onFileAdded={atLeastOnefileAdded}/>]);
    const [fileUploadedText, updateIfOneFileUploaded] = useState("No files added");

    
    
    const addDocument = () => {
        var length = documentInputList.length;
        if(documentInputList.length < 10){
            updateDocumentList(prev => prev.concat(<DocumentInputRow key={length} length={length} inputFor={inputFor} id={id} onFileAdded={atLeastOnefileAdded}/>));
        }
    }
    const removeDocument = () => {
        if(documentInputList.length > 0){
            updateDocumentList(prev => prev.slice(0,documentInputList.length-1));            
        }
    }
    return(
        <div className="col-md-4 col-sm-12 mt-2 mt-md-0">
            {/* Modal launch button */}
            <button type="button" className="btn btn-primary" data-toggle="modal" data-target={"#" +"docInput" + props.id}>
                <i>(Optional)</i><br /> Upload Documents
            </button>
            <div>
                {fileUploadedText}
            </div>
            {/* Modal */}
            <div className="modal fade" id={"docInput" + props.id} tabIndex="-1" role="dialog" aria-labelledby="documentInputModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Upload Title and other documents</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {documentInputList}
                        </div>
                        <div className="modal-footer">                            
                            <button type="button" className="btn btn-success mr-auto" data-dismiss="modal">Done</button>
                            <button type="button" onClick={() => addDocument()} className="btn btn-primary mr-1">Add document</button>
                            <button type="button" onClick={() => removeDocument()} className="btn btn-danger">Remove document</button>
                        </div>                                    
                    </div>
                </div>
            </div>
        </div>
    );


}